import React from 'react'
import { MainComponent, Component4, Texts, HeaderPart, FooterPart, SaveButton } from '../style';
import InputSelect from 'src/components/shared/Form/Select';
import theme from 'src/config/theme';
import InputComponent from 'src/components/shared/Form/Input';
import { palette, shadows } from 'src/config/theme.js';
import { alpha } from '@mui/material';
import DateTimePicker from 'src/components/App/DatePicker';
import { ReactComponent as CloseIcon } from '../../../../../../src/assets/images/close-circle.svg';
import { ReactComponent as AddIcon } from '../../../../../../src/assets/images/add-square.svg';
import ButtonComponent from 'src/components/shared/Button';
import { postBillingRequest } from 'src/modules/app/store/appActions';
import { useDispatch } from "react-redux";
import { Formik, Form } from "formik";
import * as Yup from "yup";
import dayjs from 'dayjs';
import useAppointmentDetails from '../../UseAppointmentDetails';
import toast from 'src/utils/toast';
import useResponsive from 'src/components/hooks/useResponsive';

const PayFor = [

    { label: 'Consultation', value: 'consultation' },
    { label: 'X-ray', value: 'x-ray' },
]
const Pay_Type = [
    { label: 'Credit', value: 'credit' },
    { label: 'Debit', value: 'debit' },
]
const Pay_Method = [
    { label: 'Cash', value: 'cash' },
    { label: 'Card', value: 'card' },
    { label: 'UPI', value: 'upi' },
]

function AddBilling({ onClose, updatePayment }) {
    const { PatientId, user, clinicId, appointmentId } = useAppointmentDetails();
    const { isMobile, isTablet } = useResponsive();

    // const { appointmentId } = useParams();
    const dispatch = useDispatch();
    const modifiedPayMethods = [
        {
            label: 'Total Entry', value: 'Total Entry', customStyle: {
                color: `${theme.palette.primary.main} !important`,
                '&:hover': {
                    backgroundColor: 'transparent !important',
                },
            }
        },
        ...PayFor,
    ];
    const validationSchema = Yup.object().shape({
        amount: Yup.number().required(' Amount is required'),



    })
    const handleSubmit = async (values, { resetForm }) => {
        try {
            const paymentData = {
                paymentFor: values.paymentFor,
                amount: values.amount,
                date: values.date,
                type: values.type,
                method: values.method,
                clinic: clinicId,
                patient: PatientId,
                user,
                tokenAppointment: appointmentId
            };
            const response = await new Promise((resolve, reject) => {
                dispatch(postBillingRequest(paymentData, resolve, reject));
            });

            console.log('payment added successfully', response);

            updatePayment({ ...paymentData, id: response.billing.id });

            toast.success(response.message)
            resetForm();
            onClose();
        } catch (error) {
            console.log(error.message || 'Failed to add notes', { variant: 'error' });
        }
    };
    return (
        <>
            <Formik
                enableReinitialize={true}
                initialValues={{
                    paymentFor: modifiedPayMethods?.[0]?.value,
                    amount: '',
                    date: dayjs().format('YYYY-MM-DD'),
                    type: 'debit',
                    method: 'total',

                }}
                validationSchema={validationSchema}
                onSubmit={handleSubmit}
            >
                {({ values, errors, touched, handleBlur, handleSubmit, handleChange, setFieldValue }) => (

                    <Form>
                        <HeaderPart>
                            Add Payment
                            <CloseIcon
                                width={isMobile || isTablet ? 18 : 24}
                                height={isMobile || isTablet ? 18 : 24} onClick={onClose} style={{ cursor: 'pointer' }} />
                        </HeaderPart>

                        <MainComponent>

                            <Component4 sx={{ width: isMobile || isTablet ? '280px' : '404px' }}>
                                <Texts>Payment For</Texts>
                                <InputSelect
                                    showNone={false}
                                    name="paymentFor"
                                    value={values.paymentFor}
                                    options={modifiedPayMethods}
                                    onChange={(value) => setFieldValue('paymentFor', value)}
                                    variant="outlined"
                                    placeholder="Select"
                                    sx={{
                                        // width: '200px',
                                        boxShadow: theme.shadows[1],
                                        '& .MuiOutlinedInput-root': {
                                            height: '52px',
                                            display: 'flex',
                                            alignItems: 'center',
                                            // border: `1px solid ${alpha(theme.palette.gery.black, 0.14)}`,
                                            borderRadius: '12px',
                                        },
                                    }}
                                />

                            </Component4>
                            {values.paymentFor === 'Total Entry' ? (
                                <Component4>
                                    <Texts>Total Amount</Texts>
                                    <InputComponent
                                        name="amount"
                                        value={values.amount}
                                        onChange={handleChange}
                                        variant="outlined"
                                        placeholder="Enter Total Amount"
                                        fullWidth
                                        onBlur={handleBlur}
                                        error={touched.amount && Boolean(errors.amount)}
                                        helperText={touched.amount && errors.amount}
                                        sx={{
                                            backgroundColor: palette.gery.white,
                                            boxShadow: shadows[1],
                                            '& .MuiOutlinedInput-root': {
                                                borderRadius: '12px',
                                                height: '52px',
                                            },
                                            '& .MuiOutlinedInput-notchedOutline': {
                                                border: `1px solid ${alpha(palette.gery.black, 0.14)}`,
                                            },
                                            "& .MuiInputBase-input.MuiOutlinedInput-input": {
                                                ...(isMobile || isTablet ? theme.mobileTypography.body2 : theme.typography.h5),
                                            },
                                        }}
                                    />
                                </Component4>
                            ) : (
                                <Component4>
                                    <Texts>Amount</Texts>
                                    <InputComponent
                                        name="amount"
                                        value={values.amount}
                                        onChange={handleChange}
                                        variant="outlined"
                                        placeholder="Enter Amount"
                                        fullWidth
                                        onBlur={handleBlur}
                                        error={touched.amount && Boolean(errors.amount)}
                                        helperText={touched.amount && errors.amount}
                                        sx={{
                                            backgroundColor: palette.gery.white,
                                            boxShadow: shadows[1],
                                            '& .MuiOutlinedInput-root': {
                                                borderRadius: '12px',
                                                height: '52px',
                                            },
                                            '& .MuiOutlinedInput-notchedOutline': {
                                                border: `1px solid ${alpha(palette.gery.black, 0.14)}`,
                                            },
                                            "& .MuiInputBase-input.MuiOutlinedInput-input": {
                                                ...(isMobile || isTablet ? theme.mobileTypography.body2 : theme.typography.h5),
                                            },
                                        }}
                                    />
                                </Component4>
                            )}



                            <Component4>
                                <Texts>Payment Date</Texts>
                                <DateTimePicker
                                    name="date"
                                    value={values.date}
                                    onChange={(val) => setFieldValue('date', val)}
                                    fullWidth
                                    type="date"
                                    disabled={values.paymentFor === 'Total Entry'}
                                    sx={{
                                        height: "52px",
                                        borderRadius: '12px',
                                        // padding: '10px 16px',
                                    }}
                                />
                            </Component4>
                            <Component4>
                                <Texts>Payment Type</Texts>
                                <InputSelect

                                    name="type"
                                    value={values.type}
                                    options={Pay_Type}
                                    showNone={false}
                                    onChange={(value) => setFieldValue('type', value)}
                                    variant="outlined"
                                    placeholder="Select"
                                    disabled={values.paymentFor === 'Total Entry'}
                                    sx={{
                                        // width: '200px',
                                        boxShadow: theme.shadows[1],
                                        '& .MuiOutlinedInput-root': {
                                            height: '52px',
                                            display: 'flex',
                                            alignItems: 'center',
                                            // border: `1px solid ${alpha(theme.palette.gery.black, 0.14)}`,
                                            borderRadius: '12px',
                                        },
                                    }}
                                />

                            </Component4>
                            <Component4>
                                <Texts>Method</Texts>
                                <InputSelect
                                    name="method"
                                    value={values.method}
                                    options={Pay_Method}
                                    onChange={(value) => setFieldValue('method', value)}
                                    variant="outlined"
                                    placeholder="Select"
                                    disabled={values.paymentFor === 'Total Entry'}

                                    sx={{
                                        // width: '200px',
                                        boxShadow: theme.shadows[1],
                                        '& .MuiOutlinedInput-root': {
                                            height: '52px',
                                            display: 'flex',
                                            alignItems: 'center',
                                            // border: `1px solid ${alpha(theme.palette.gery.black, 0.14)}`,
                                            borderRadius: '12px',
                                        },
                                    }}
                                />

                            </Component4>

                        </MainComponent>
                        <FooterPart >
                            <ButtonComponent
                                variant="none"
                                startIcon={<CloseIcon
                                    width={isMobile || isTablet ? 18 : 24}
                                    height={isMobile || isTablet ? 18 : 24} sx={{ color: palette.primary.main }} />}
                                onClick={onClose}
                            >
                                Cancel
                            </ButtonComponent>



                            <SaveButton
                                type="submit"
                                variant="outlined"
                                startIcon={<AddIcon width={isMobile || isTablet ? 18 : 24}
                                    height={isMobile || isTablet ? 18 : 24} sx={{ color: theme.palette.primary.main }} />}
                            >Save</SaveButton>
                        </FooterPart>
                    </Form>
                )}
            </Formik>
        </>
    )
}

export default AddBilling
